<template>
<section id="company-select">
    <NavbarDefault selection route="/" />
    <div class="container">
        <div class="row d-flex justify-content-center pt-5 mb-0">
            <div class="col-11 offset-1">
                <Button @click="backStep" size="small" type="outline" color="grey">
                    <ArrowDropdown :rotate="90" /> Voltar
                </Button>
            </div>
        </div>
        <div class="row d-flex justify-content-center align-items-center new-company">
            <div class="col-4">
                <h2 :class="`text-center c-${getPrimaryColor}four`">Nova empresa</h2>
                <p class="text-center mb-5">
                    Informe o CNPJ da empresa a ser cadastrada.
                </p>
                <el-form @change="validateForm" :model="company" ref="company" :rules="rules" @keyup.native="validateForm" class="mt-5" @submit.native.prevent="validateForm">
                    <div class="mb-5">
                        <el-form-item prop="cnpj" :class="!cnpjOk ? 'is-error' : ''">
                            <!-- <InputText  v-model="company.cnpj" label="CNPJ" placeholder="CNPJ da empresa" v-mask="'##.###.###/####-##'"/> -->
                            <label>CNPJ</label>
                            <el-input :class="getPrimaryColor" v-model="company.cnpj" placeholder="CNPJ da empresa" v-mask="'##.###.###/####-##'" />
                        </el-form-item>
                    </div>
                    <div class="feedback my-4" v-if="formValid && $store.state.user.loading == false">
                        <CnpjNameCard v-if="cnpjOk" :name="company.name" />
                        <AlreadyRegisteredCnpjCard v-else-if="registeredCnpj" />
                    </div>
                    <Button size="large" :disabled="!formValid || !cnpjOk" @click="nextStep" :color="getPrimaryColor">
                        Confirmar
                    </Button>
                </el-form>
            </div>
        </div>
    </div>
    <Footer />
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
</section>
</template>

<script>
import CnpjNameCard from '@/components/cards/CnpjNameCard'
import AlreadyRegisteredCnpjCard from '@/components/cards/AlreadyRegisteredCnpjCard'
import Footer from '@/components/navigation/footer/Footer'
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import removeMask from '@/utils/removeMask'
import getCompanyName from '@/api/getCompanyName'
import insertCompany from '@/api/insertCompany'
import FullLoading from '@/components/loading/FullLoading'
import getPartner from '@/utils/getPartner'
import validateCnpjType from '@/api/validateCnpjType'
import insertBuyersEconomicGroup from '@/api/insertBuyersEconomicGroup'
import insertProvidersEconomicGroup from '@/api/insertProvidersEconomicGroup'
import setSponsorPartners from '@/api/setSponsorPartners'

export default {
    components: {
        CnpjNameCard,
        AlreadyRegisteredCnpjCard,
        Footer,
        ArrowDropdown,
        FullLoading,
        NavbarDefault
    },
    data() {
        const validateCnpj = (_rule, value, message) => {
            if (this.incorretCnpj.includes(value)) message('Número de CNPJ incorreto.')
            else message()
        }
        return {
            company: {
                cnpj: '',
                name: '',
                companyType: '',
                partners: [],
            },
            rules: {
                cnpj: [{
                        required: true,
                        message: 'Por favor, insira o CNPJ da sua empresa',
                        trigger: 'change'
                    },
                    {
                        min: 18,
                        message: 'O CNPJ deve ter 14 caracteres',
                        trigger: 'change'
                    },
                    {
                        validator: validateCnpj,
                        trigger: 'change'
                    }
                ],
            },
            formValid: false,
            cnpjOk: false,
            incorretCnpj: '',
            registeredCnpj: false,
            registeredCompany: null,
        }
    },
    watch: {
        formValid(val) {
            if (val) {
                this.requestCompanyName()
            }
        },
    },
    methods: {
        validateForm() {
            this.$refs['company'].validate(async (valid) => {
                if (valid) {
                    this.formValid = true    
                } else {
                    this.formValid = false
                }
            });
        },
        async requestCompanyName() {            
            this.cnpjOk = false
            this.registeredCnpj = false

            const sanitizedCnpj = removeMask(this.company.cnpj)
            const companyType = this.$route.params.type
            const validateCnpjAndType = await validateCnpjType(sanitizedCnpj, companyType)

            if (validateCnpjAndType) {
                this.cnpjOk = true
                this.registeredCompany = validateCnpjAndType
                this.company.name = validateCnpjAndType.companyName
                this.company.partners = validateCnpjAndType.partners
            } else {                
                const result = await getCompanyName(sanitizedCnpj)

                if (result.ok) {
                    this.cnpjOk = true
                    this.company.name = result.payload
                } else {
                    this.incorretCnpj = this.company.cnpj
                    this.validateForm()
                }
            }
        },
        backStep() {
            if (this.$route.params.groupId || this.$route.params.partnerId) this.$router.go(-1)
            if (this.$route.params.type == '0') this.$router.push(`/company/sponsor`)
            if (this.$route.params.type == '1') this.$router.push(`/company/provider`)
            if (this.$route.params.type == '2') this.$router.push(`/company/buyer`)
        },
        async nextStep() {
            const partner = await getPartner(this.getWhiteLabel)
            let result = {}

            if (this.registeredCompany) {
                result = this.registeredCompany
            } else {
                result = await insertCompany({
                    cnpj: removeMask(this.company.cnpj),
                    companyType: this.company.companyType,
                    partner,
                })
            }

            if (result.ok && !this.registeredCompany) {
                const id = result.payload.cnpjId
                const companyId = result.payload.id
                const companyType = this.$route.params.type
                if (this.$route.params.groupId || this.$route.params.partnerId) {
                    switch (companyType) {
                        case '0': 
                            await setSponsorPartners({ cnpjId: id, partners: [ parseInt(this.$route.params.partnerId) ] })
                            break
                        case '1':
                            await insertProvidersEconomicGroup(this.$route.params.groupId, { providerIds: [companyId] })
                            break
                        case '2':
                            await insertBuyersEconomicGroup(this.$route.params.groupId, { buyerIds: [companyId] })
                            break
                    }
                    this.$router.go(-1)
                } else {
                    if (companyType == '0') this.$router.push(`/sponsor/register/${id}/0`)
                    if (companyType == '1') this.$router.push(`/provider/register/${id}/0`)
                    if (companyType == '2') this.$router.push(`/buyer/register/${id}/0`)
                }
                
            } else if (this.registeredCompany) {
                const { cnpjId, companyId } = result
                const companyType = this.$route.params.type
                let insertBuyer = null

                switch (companyType) {
                    case '0': 
                        await setSponsorPartners({ cnpjId, partners: [ ...this.company.partners, parseInt(this.$route.params.partnerId) ] })
                        break
                    case '1':
                        await insertProvidersEconomicGroup(this.$route.params.groupId, { providerIds: [companyId] })
                        break
                    case '2':
                        insertBuyer = await insertBuyersEconomicGroup(this.$route.params.groupId, { buyerIds: [companyId] })
                        break
                }

                if (insertBuyer?.data.payload.buyersAddedToGroup.length === 0) {
                    this.cnpjOk = false
                    this.registeredCnpj = true
                } else {
                    this.$router.go(-1)
                }
            } else {
                if (result.data.message == 'cnpj already exists') {
                    this.cnpjOk = false
                    this.registeredCnpj = true
                }
            }

        }
    },
    created() {
        this.company.companyType = this.$route.params.type
    },
}
</script>

<style scoped>
.width-880 {
    max-width: 880px;
}
</style>
